/* eslint-disable no-shadow */
const state = {
	vendorAuthenticated: false,
	status: [],
	vendorData: [],
	razorPayCustomSubscriptionOrderData: {}
}

const getters = {
	isVendorAuthenticated: state => state.vendorAuthenticated,
	getStatusData: state => state.status,
	getVendorData: state => state.vendorData,
	getSubscriptionOrderData: state => state.razorPayCustomSubscriptionOrderData
}

const mutations = {
	setVendorAuthenticatedMutation: (state, payload) => {
		state.vendorAuthenticated = payload
	},
	setStatusDataMutation: (state, payload) => {
		state.status = payload
	},
	setVendorDataMutation: (state, payload) => {
		state.vendorData = payload
	},
	setSubscriptionOrderDataMutation: (state, payload) => {
		state.razorPayCustomSubscriptionOrderData = payload
	}
}

const actions = {
	setVendorAuthenticated: ({ commit }, payload) => {
		commit('setVendorAuthenticatedMutation', payload)
	},
	setStatusData: ({ commit }, payload) => {
		commit('setStatusDataMutation', payload)
	},
	setVendorData: ({ commit }, payload) => {
		commit('setVendorDataMutation', payload)
	},
	setSubscriptionOrderData: ({ commit }, payload) => {
		commit('setSubscriptionOrderDataMutation', payload)
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}
